'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = clone;

var _sharedTypeUtils = require('../shared/type-utils');

function clone(obj) {
  if (obj == null || typeof obj !== 'object') {
    return obj;
  }

  var temp = null;

  if ((0, _sharedTypeUtils.isDate)(obj)) {
    temp = new Date(obj.getTime());
  } else {
    temp = obj.constructor();
    for (var key in obj) {
      temp[key] = clone(obj[key]);
    }
  }

  return temp;
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/utils/clone.js
// module id = 71
// module chunks = 0